export default __webpack_public_path__ + "static/media/wine2.732eb251.png";